export default "__VITE_ASSET___V5UULzw__"